import { CallOffOrderDetail, RequestDelivery } from '@ravago/shared/page-data/models/elements';

export async function getCallOffOrderDetail(orderId: string): Promise<CallOffOrderDetail | undefined> {
  const response = await fetch(`/api/orders/call-off/${orderId}`);

  if (!response.ok) {
    return undefined;
  }

  return response.json();
}

export async function requestDelivery(delivery: RequestDelivery): Promise<boolean> {
  const response = await fetch(`/api/orders/call-off/${delivery.callOffOrderId}/request-delivery`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(delivery)
  });

  return response.ok;
}
